/* ------------------------------------------ GRYFF PRODUCT SELECTOR - CHRIS 18.08.2016 ----------------------------------------- */

/**
 * Update 01/2020
 * Swatches option background data structure
 *
 * Ex.1. Auto image background
 *      {
 *          type: "image"
 *      }
 *
 * Ex.2. Auto color background
 *      {
 *          type: "color"
 *      }
 *
 * Ex.3. Manual image background
 *      {
 *          type: "manual",
 *          variants: {
 *              variant_1: {
 *                  type: "image",
 *                  value: "https://image.com/nature.jpg"
 *              }
 *          }
 *      }
 *
 * Ex.4. Manual color background
 *      {
 *          type: "manual",
 *          variants: {
 *              variant_1: {
 *                  type: "color"
 *                  value: "#ff0000"
 *              }
 *          }
 *      }
 */

import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import store from '@/app/store/store';

(function (jQuery) {
  jQuery.gfSwatcherV1 = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const $cSelector = jQuery(
      '<a id="gf-swatches-editor" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Open Manager</a>',
    );
    const _mdProductSelector = '<div id="md-swatches-editor"></div>';

    let _productData;
    const $activeModal = jQuery(_mdProductSelector);
    let $productList;

    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $divTopBar = getGlobalVariable('divTopBar');
    const $divContentHidden = getGlobalVariable('divContentHidden');
    const $gfFrame = getGlobalVariable('gfFrame');
    const $gryffBody = getGlobalVariable('gryffBody');

    let currentSettings;
    let oldSettings;
    const _content =
      '<div class="gfPS_search"><input type="text" id="search-product" name="search-product" value="" placeholder="Search option..." /> ' +
      utils.svgIcon('search') +
      ' </div> <div class="gfPS_body"> <div class="product-list"> <p class="text-center"></p> </div> <div class="search_notfound"> <span class="gfPS_icon_notfound"></span> <span class="text">No Variants Found</span> </div> </div> <div class="gfPS_footer"> <button id="btnSaveSwatches" class="btn btn-primary" disabled>Save</button> <button class="btn btn-grey" id="btnCancelSwatches" class="cancel">Cancel</button> </div>';

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      $element.after($cSelector);

      this.applyEvents();
    };

    this.showSwatchesEditor = async function () {
      try {
        currentSettings = JSON.parse(decodeURIComponent(escape(window.atob($element.val()))));
        oldSettings = $element.val();
      } catch (e) {
        currentSettings = {};
      }

      if ($activeModal.data('gfmodalnew')) {
        $activeModal.data('gfmodalnew').onShow();
        _this.offLoading();
        return false;
      }

      $activeModal.appendTo($divContentHidden);
      $activeModal.gfModalNew({
        title: 'Swatches Background Manager',
        header: 'noIcon',
        footer: '',
        background: '#F3F5F9',
        width: 400,
        height: 640,
        heightOverLay: '80%', // Để cho phép click cancel, ovelay không phủ hết xuống button
        topOverlay: '10%',
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        loading: true,
        svgIconClose: 'close16',
        onContent: function ($content) {
          $content.html(_content);
        },
        onClose: function () {
          $activeModal.remove();
        },
      });

      $activeModal.data('gfmodalnew').onShow();

      // Click btn Cancel
      $activeModal
        .find('.gfPS_footer #btnCancelSwatches')
        .off('click.swatchesbg')
        .on('click.swatchesbg', function () {
          $activeModal.remove();
        });

      // update stuffs
      $productList = $activeModal.find('.product-list');
      const swatchesData = await HELPER.getSwatchesOptions();
      let currentOptionTemplate = '';
      let globalOptionTemplate = '';

      currentOptionTemplate +=
        '<div class="gf_swatches-group gf_swatches-current"><div class="gf_swatches-group-header">Current<span class="gf_swatches-option-toggler">' +
        utils.svgIcon('toggler') +
        '</span></div><ul class="items option-list">';
      globalOptionTemplate +=
        '<div class="gf_swatches-group gf_swatches-global"><div class="gf_swatches-group-header">Others<span class="gf_swatches-option-toggler">' +
        utils.svgIcon('toggler') +
        '</span></div><ul class="items option-list">';

      const $activeModule = _this.getActiveModule();
      const currentOptions = {};
      $activeModule.find('.gf_swatches-selector').each(function (index, el) {
        const $selector = jQuery(el);
        const optionName = $selector.attr('data-name');
        if (optionName) {
          if (!currentOptions[optionName]) {
            currentOptions[optionName] = [];
          }
        }

        const $gfSwatch = $selector.children('.gf_swatch');
        const gfSwatchLength = $gfSwatch.length;
        for (let i = 0; i < gfSwatchLength; i++) {
          const item = $gfSwatch[i];
          currentOptions[optionName].push(jQuery(item).text().trim());
        }
      });

      let option;

      //hotfix add current Product SwatchesData
      const swatchesId = $gfLeftSideBar.find('#md-settings').data('edittingID') || '';
      if (swatchesId) {
        const $swatches = $gryffBody.find('#' + swatchesId);
        const $productModule = $swatches.closest('[data-label="Product"]');
        const productId = $productModule.children('.module').attr('data-pid');
        const productData = _this.getCurrentProduct(productId);
        if (productData && productData.options) {
          const optionLength = productData.options.length;
          for (let j = 0; j < optionLength; j++) {
            const name = productData.options[j].name;
            const values = productData.options[j].values;
            if (name && values) {
              if (!swatchesData[name]) {
                swatchesData[name] = [];
              }
              const valuesLength = values.length;
              for (let k = 0; k < valuesLength; k++) {
                if (swatchesData[name].indexOf(values[k]) == -1) {
                  swatchesData[name].push(values[k]);
                }
              }
            }
          }
        }
      }

      for (option in swatchesData) {
        const optionTemplate =
          '<li class="item" data-level="1">' +
          '<div class="gf_swatches-option-title">' +
          '<span class="gf_swatches-option-name">' +
          option +
          '</span>' +
          '</div>' +
          '<div class="gfPR_form-items"> <div class="gfPR_columns"> <div class="gfSGSettings" data-option="' +
          option +
          '">' +
          _this.renderField(currentSettings[option] || {}, swatchesData[option], currentOptions[option] || []) +
          '</div> </div> </div> </li>' +
          '</li>';

        if (currentOptions[option]) {
          currentOptionTemplate += optionTemplate;
        } else {
          globalOptionTemplate += optionTemplate;
        }
      }

      currentOptionTemplate += '</ul></div>';
      globalOptionTemplate += '</ul></div>';
      const html = `${currentOptionTemplate}${globalOptionTemplate}`;

      $productList.html(html);

      _this.applyPopupEvents();

      _this.offLoading();

      $activeModal
        .find('#search-product')
        .off('keyup paste')
        .on('keyup paste', function () {
          const input = jQuery(this).val().trim().toLowerCase();
          $activeModal.find('.gf_swatches-group-header').removeClass('closed');
          $activeModal.find('ul.items.option-list > li').each(function (index, item) {
            const $item = jQuery(item);
            const optionName = $item.find('.gf_swatches-option-name').text().trim().toLowerCase();
            $item.removeClass('show').find('.gfSGSettings').removeClass('show');
            if (optionName.indexOf(input) != -1) {
              $item.show();
            } else {
              $item.hide();
            }
          });
        });

      // Save
      $activeModal
        .find('#btnSaveSwatches', '.gfPS_footer')
        .off('click.swatchesbg')
        .on('click.swatchesbg', function () {
          const newSettings = window.btoa(unescape(encodeURIComponent(JSON.stringify(currentSettings))));
          $element.attr('value', newSettings).val(newSettings).trigger('input-change').trigger('value-change');
          $activeModal.remove();
          if (oldSettings != newSettings) {
            setTimeout(() => {
              store.setValue('__isSaved', false);
            });
          }
        });

      return false;
    };

    this.offLoading = function () {
      $activeModal.find('#btnSaveSwatches').removeAttr('disabled');
      if ($activeModal.data('gfmodalnew')) {
        $activeModal.data('gfmodalnew').offLoading();
      }
    };

    this.getCurrentProduct = function (productId) {
      const $gryffEditor = getGlobalVariable('gryffEditor');
      if ($gryffEditor.data('gryffeditor') != undefined) {
        return $gryffEditor.data('gryffeditor').searchProductInList(productId);
      }
      return false;
    };

    this.renderField = function (settings, variants, currentVariants) {
      const enable = !jQuery.isEmptyObject(settings);
      let currentVariantTemplate = '';
      let globalVariantTemplate = '';

      let html = `<div class="gfPR_form-item">
                 <input type="text" name="enable" class="gf_to-switch" value="${enable ? 1 : 0}" default_value="${
        enable ? 1 : 0
      }" data-description="Background" data-caption="Background">                
             </div>
             <div class="gfPR_form-item">
                 <input type="text" name="mode" class="gf_to-segment" data-level="2" data-multiple="false" data-icon="false" data-value="auto,manual" data-columns="Auto,Manual" value="${
                   settings.type == 'manual' ? 'manual' : 'auto'
                 }" data-disable="false" data-description="" data-caption="Source">                
             </div>
             <div class="gfPR_form-item">
                 <select name="type" value="${settings.type == 'color' ? 'color' : 'image'}" default_value="${
        settings.type == 'color' ? 'color' : 'image'
      }" data-description="" data-caption="Type" data-level="2-1">
                     <option value="image">Image</option>
                     <option value="color">Color</option>
                 </select>                
             </div>
             <div class="gfPR_form-item">
                 <div class="gfPS_search-variant">
                     ${utils.svgIcon('search')}
                     <input type="text" name="search-variant" value="" placeholder="Search variant..." />
                 </div>
             </div>
             <div class="gfPR_form-item">
                 <ul class="items">`;

      const variantLength = variants.length;
      for (let i = 0; i < variantLength; i++) {
        const variantSettings =
          settings.variants && settings.variants[variants[i]] ? settings.variants[variants[i]] : {};

        const variantTemplate = `<li class="item" index="${i}">
                         <span class="gfRP_icon">
                         <div class="gf_swatches-variant-title">
                         <span class="gfRP_color" style="background-color: ${
                           variantSettings.type == 'color' ? variantSettings.value : ''
                         }">
                             ${variantSettings.type == 'image' ? '<i class="gpicon-image"></i>' : ''}
                         </span>
                         <span class="gfRP_title rp-handle">${variants[i]}</span>
                         </div>
                         <div class="gfPR_form-items">
                             <div class="gfPR_columns">
                                 <div class="gfSGSettings">
                                     <input type="text" class="background-v2" name="background-v2" value="${
                                       variantSettings.type || 'color'
                                     }" data-hide="false" data-type="hidden" data-alpha="true"/>
                                     <input type="text" name="color" requires="background-v2|color" class="gryff-color" value="${
                                       variantSettings.type == 'color' && variantSettings.value
                                         ? variantSettings.value
                                         : ''
                                     }" data-alpha="true" data-hide="false" data-type="hidden" />
                                     <input type="text" name="image" requires="background-v2|image" class="gf_to-photoPicker ui-dform-text" data-caption="Image" value="${
                                       variantSettings.type == 'image' && variantSettings.value
                                         ? variantSettings.value
                                         : ''
                                     }" data-height="36" />
                                 </div>
                             </div>
                         </div>
                     </li>`;

        if (currentVariants.indexOf(variants[i]) != -1) {
          currentVariantTemplate += variantTemplate;
        } else {
          globalVariantTemplate += variantTemplate;
        }
      }
      html += `${currentVariantTemplate} ${globalVariantTemplate}
                     </ul>
                 </div>
             `;

      return html;
    };

    this.applyEvents = function () {
      $cSelector.off('click.swatchesbg').on('click.swatchesbg', function () {
        _this.showSwatchesEditor();
      });

      $element.off('mousedown.swatchesbg').on('mousedown.swatchesbg', function () {
        $cSelector.trigger('click');
        return false;
      });

      return false;
    };

    this.renderLevel2 = function ($item) {
      // Render segment
      const $dataLevel2 = $item.find('input[data-level=2]');
      if (!_this.isRendered($dataLevel2)) {
        const settingChangeHandler = function (value, $el) {
          _this.settingChangeHandlerBody(value, $el, $dataLevel2, $item);
        };
        $dataLevel2.gfSegment({
          value: 1,
          onSelected: settingChangeHandler,
        });
        _this.addRendered($dataLevel2);
      }

      // Render dropdown
      const $dataLevel2dot1 = $item.find('select[data-level=2-1]');
      const title = $dataLevel2dot1.attr('data-caption');
      if (!_this.isRendered($dataLevel2dot1)) {
        const settingChangeHandler = function (value, $el) {
          _this.settingChangeHandlerBody(value, $el, $dataLevel2dot1, $item);
        };
        const value = $dataLevel2dot1.val();
        $dataLevel2dot1.gfDropDown({
          title: title,
          value: value,
          onSelected: settingChangeHandler,
        });
        _this.addRendered($dataLevel2dot1);
      }
    };

    this.settingChangeHandlerBody = function (value, $el, $inputElement, $item) {
      const fromLevel = $item.attr('data-level');
      switch (fromLevel) {
        case '1':
          _this.renderLevel2($item);
          break;
      }

      const $wrapper = $el.closest('.gfSGSettings[data-option]');
      const option = $wrapper.attr('data-option');
      const bgEnable = $wrapper.find('input[name="enable"]').val() || '0';
      const bgMode = $wrapper.find('input[name="mode"]').val() || 'auto';
      const autoType = $wrapper.find('select[name="type"]').val() || 'image';

      setTimeout(function () {
        if (option) {
          if (bgEnable == '1') {
            if (bgMode == 'manual') {
              const variants =
                currentSettings[option] && currentSettings[option].variants ? currentSettings[option].variants : {};
              currentSettings[option] = {
                type: 'manual',
                variants: variants,
              };

              const $itemList = $wrapper.find('ul.items > li');
              const itemLength = $itemList.length;
              for (let i = 0; i < itemLength; i++) {
                const item = $itemList[i];
                const $item = jQuery(item);

                const variantName = $item.find('.gfRP_title').text();
                let manualType = $item.find('input[name="background-v2"]').val() || 'color';
                const manualColor = $item.find('input[name="color"]').attr('value') || '';
                const manualImage = $item.find('input[name="image"]').attr('value') || '';

                if ($el.attr('id') === 'background-v2') {
                  manualType = value;
                }

                if (manualType == 'color') {
                  if (manualColor != '') {
                    currentSettings[option].variants[variantName] = {
                      type: 'color',
                      value: manualColor,
                    };

                    $item.find('.gfRP_color').html('').css('background-color', manualColor);
                  }
                } else {
                  if (manualImage != '') {
                    currentSettings[option].variants[variantName] = {
                      type: 'image',
                      value: manualImage,
                    };

                    $item.find('.gfRP_color').html('<i class="gpicon-image"></i>').css('background-color', '');
                  }
                }
              }
            } else {
              currentSettings[option] = {
                type: autoType,
              };
            }
          } else {
            delete currentSettings[option];
          }
        }

        _this.updateRequires($inputElement);
      }, 500);
    };

    this.isRendered = function ($item) {
      const uiRendered = $item.attr('data-ui-rendered');
      return !!uiRendered;
    };

    this.addRendered = function ($item) {
      $item.attr('data-ui-rendered', 1);
    };

    this.renderControls = function ($item) {
      const dataLevel = $item.attr('data-level');
      switch (dataLevel) {
        case '1':
          if (!_this.isRendered($item)) {
            const $toggleSwitch = $item.find('input.gf_to-switch');
            const settingChangeHandler = function (value, $el) {
              _this.settingChangeHandlerBody(value, $el, $toggleSwitch, $item);
            };
            $toggleSwitch.gfSwitcher({
              value: 1,
              onSelected: settingChangeHandler,
            });
            _this.addRendered($item);
          }
          break;
        default:
          break;
      }
      _this.renderLevel2($item);
    };

    this.applyPopupEvents = function () {
      $productList
        .find('.gf_swatches-group-header')
        .off('click.swatchesbg')
        .on('click.swatchesbg', function () {
          const $optionGroup = jQuery(this);
          $optionGroup.toggleClass('closed');
        });

      $productList
        .find(`ul.items > li > .gf_swatches-option-title, ul.items > li > span > .gf_swatches-variant-title`)
        .off('click.swatchesbg')
        .on('click.swatchesbg', function () {
          const $item = jQuery(this).parent();
          const $parent = $item.closest('.gfRP_icon');
          const $gryffColor = $parent.find('.gryff-color');
          const $gryffPhotoPicker = $parent.find('.gf_to-photoPicker');
          const $backgroundV2 = $parent.find('.background-v2');

          // Init color picker ui
          if ($gryffColor.length > 0) {
            if (!_this.isRendered($gryffColor)) {
              const settingChangeHandler = function (value, $el) {
                _this.settingChangeHandlerBody(value, $el, $gryffColor, $item);
              };
              const title = $gryffColor.attr('data-caption');
              const value = $gryffColor.val();
              $gryffColor.gfColorPicker({
                title: title,
                addHistory: false,
                value: value,
                onSelected: settingChangeHandler,
              });
              _this.addRendered($gryffColor);
            }
          }

          // Init photo picker
          if ($gryffPhotoPicker.length > 0) {
            if (!_this.isRendered($gryffPhotoPicker)) {
              const settingChangeHandler = function (value, $el) {
                _this.settingChangeHandlerBody(value, $el, $gryffPhotoPicker, $item);
              };
              const title = $gryffPhotoPicker.attr('data-caption');
              $gryffPhotoPicker.gfPhotoPicker({
                title: title,
                option: 'noSrc',
                addHistory: false,
                onSelected: settingChangeHandler,
              });
              _this.addRendered($gryffPhotoPicker);
            }
          }

          // Init tag switch from photoPicker & photoPicker
          if ($backgroundV2.length > 0) {
            if (!_this.isRendered($backgroundV2)) {
              const settingChangeHandler = function (value, $el) {
                _this.settingChangeHandlerBody(value, $el, $backgroundV2, $item);
              };
              $backgroundV2.gfBackgroundV2({
                onSelected: settingChangeHandler,
              });
              _this.addRendered($backgroundV2);
            }
          }

          const isOpening = $item.hasClass('show');
          if (isOpening) {
            $item.removeClass('show');
            $item.find('.gfSGSettings').first().removeClass('show');
          } else {
            // Render now
            _this.renderControls($item);
            $item.addClass('show');
            $item.find('.gfSGSettings').first().addClass('show');
          }
        });

      const $productListEnable = $productList.find('input[name="enable"]');
      const pListLength = $productListEnable.length;
      for (let i = 0; i < pListLength; i++) {
        const item = $productListEnable[i];
        _this.updateRequires(jQuery(item));
      }
    };

    this.searchProducts = async function (s, count) {
      const shop = $gfFrame.data('gfframe').getShopDomain();

      const data = {
        shop: shop,
        s: s,
        limit: 249,
      };
      try {
        const res = await GET(api.searchProducts().url, data);
        const jsonData = res.data;
        if (!jQuery.isEmptyObject(jsonData)) {
          const _products = jsonData['products'];
          // Check search !== search off
          const productDataLength = _productData.length;
          const pLength = _products.length;
          for (let i = 0; i < productDataLength; i++) {
            for (let j = 0; j < pLength; j++) {
              if (_products[j].id == _productData[i].id) {
                _products.splice(j, 1);
              }
            }
          }

          const productLength = _products.length;
          // push store data
          for (let i = 0; i < productLength; i++) {
            _productData.push(_products[i]);
          }

          if (productLength > 0) {
            let html = '';
            for (let i = 0; i < productLength; i++) {
              const productItem = _products[i];
              html +=
                '<li data-pid="' +
                productItem.id +
                '" data-pHandle="' +
                productItem.handle +
                '" data-pTitle="' +
                productItem.title +
                '">';

              if (productItem.image && productItem.image.src) {
                // Src image small
                const smallSrc = HELPER.getImageSmall(productItem.image.src, {
                  width: 40,
                  height: 40,
                });
                html += '<div class="gfPS_thumbnail">';
                html += '<img src="' + smallSrc + '" />';
                html += '</div>';
              } else {
                html += '<div class="gfPS_thumbnail">';
                html += '<div class="gfPS_icon_thumbnail"></div>';
                html += '</div>';
              }

              html += '<span>' + productItem.title + '</span>';

              html += '</li>';
            }
            $productList.find('ul').append(html);
            _this.bindProductEvents();
          } else {
            if (count == 0) {
              // not found
              $activeModal.find('.search_notfound').addClass('active');
            }
          }
        }
      } catch (error) {
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        // not found
        $activeModal.find('.search_notfound').addClass('active');
      }
      return false;
    };

    this.updateRequires = function (el) {
      const $el = jQuery(el);
      const $wrapper = $el.closest('.gfSGSettings[data-option]');
      const bgEnable = $wrapper.find('input[name="enable"]').val() || '0';
      const bgMode = $wrapper.find('input[name="mode"]').val() || 'auto';

      if (bgEnable == '1') {
        $wrapper.children('.gfPR_form-item:not(:first-child)').show();

        if (bgMode == 'manual') {
          $wrapper.find('.gfPR_form-item:nth-child(3)').hide();
          $wrapper.find('.gfPR_form-item:nth-child(4)').show();
          $wrapper.find('.gfPR_form-item:nth-child(5)').show();

          $wrapper
            .find('input[name="search-variant"]')
            .off('keyup paste')
            .on('keyup paste', function () {
              const input = jQuery(this).val().trim().toLowerCase();
              const $variantWrapper = jQuery(this).closest('.gfPR_form-item').next('.gfPR_form-item');
              $variantWrapper.find('.gfRP_icon, .gfSGSettings').removeClass('show');
              $wrapper.find('ul.items > li').each(function (index, item) {
                const $item = jQuery(item);
                const variantName = $item.find('.gfRP_title').text().trim().toLowerCase();
                if (variantName.indexOf(input) != -1) {
                  $item.show();
                } else {
                  $item.hide();
                }
              });
            });
        } else {
          $wrapper.find('.gfPR_form-item:nth-child(3)').show();
          $wrapper.find('.gfPR_form-item:nth-child(4)').hide();
          $wrapper.find('.gfPR_form-item:nth-child(5)').hide();
        }
      } else {
        $wrapper.children('.gfPR_form-item:not(:first-child)').hide();
      }
    };

    this.getActiveModule = function () {
      const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
      return $gryffBody.find(`#m-${moduleId}`);
    };

    this.init();
  };

  jQuery.fn.gfSwatcherV1 = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfswatcher')) {
        const plugin = new jQuery.gfSwatcherV1(this, options);
        jQuery(this).data('gfswatcher', plugin);
      }
    });
  };
})(jQuery);
